import { useQuery } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS from 'services/urls';
import { TimelineSection } from 'views/Tasks/Timeline/types';

export const getTimelineSections = async (
    { orgId, dealId }: { orgId: string; dealId: number },
): Promise<TimelineSection[]> => {
    const response = await axiosInstance.get<TimelineSection[]>(API_ENDPOINTS.TIMELINE_SECTIONS(orgId, dealId));
    return response.data;
};

export const useGetTimelineSections = ({ orgId, dealId }: { orgId: string; dealId: number }) => useQuery({
    queryKey: ['timelineSections', orgId, dealId],
    queryFn: () => getTimelineSections({ orgId, dealId }),
});
